export default __webpack_public_path__ + "static/media/medicalenggrepeaterbanner.0a3005d3.png";